import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_debounced_function } from '@/hooks/debounce/use_debounced_function';
import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import { local_ml_asset_set_current_table_page_settings } from '@/state/diffusion_models_ud/local_ml_asset_set_current_table_page_settings';
import { EDiffusionModelsFilterType } from '../../_base/enums/e_page_diffusion_models_filter_type';
import { DiffusionModelsFilterListModelType } from '../../_base/filters/diffusion_models_filter_list_model_type';

interface Props {}

export function DiffusionModelsFilterListModelTypeUD({}: Props) {
  const dispatch = use_dispatch();

  const { current_table } = use_slice_ml_asset(['current_table']);
  const { current_table_page_settings } = use_slice_ml_asset(['current_table_page_settings']);

  /*
   * EVENTS
   */

  function on_value_change(value: string) {
    try_set_type_debounced(value);
  }

  /*
   * METHODS
   */

  function try_set_type(value: string) {
    let filter_type = value === EDiffusionModelsFilterType.ALL ? '' : value;

    if (current_table_page_settings.filter_type == filter_type) return;

    let current_table_page_settings_new = current_table_page_settings.clone({ filter_type });

    dispatch(local_ml_asset_set_current_table_page_settings(current_table_page_settings_new));
  }

  let try_set_type_debounced = use_debounced_function(try_set_type, CONSTANTS_TIME__client.DEBOUNCE_LOAD_DIFFUSION_MODELS);

  /*
   * HTML
   */

  return <DiffusionModelsFilterListModelType {...{ current_table, current_table_page_settings, on_value_change }} />;
}
